import { Injectable } from '@angular/core';
import { BaseChainBaseGuard } from '../../internal';
import { delay, first, lastValueFrom } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class LoginAuthorGuard extends BaseChainBaseGuard {
  override async canActivate(): Promise<boolean> {

    let user = this.baseChainGuardFacade.snapshot_user();

    if (!user) {
      this.baseChainGuardFacade.requestMe();
      await lastValueFrom(this.baseChainGuardFacade.ofActionDispatchedMeSuccess.pipe(first(), delay(1)));
      user = this.baseChainGuardFacade.snapshot_user();
    }

    return true; 
  }
}
